import { render } from "./NewAssetRegister.vue?vue&type=template&id=7b2599e4&scoped=true&ts=true"
import script from "./NewAssetRegister.vue?vue&type=script&lang=ts"
export * from "./NewAssetRegister.vue?vue&type=script&lang=ts"

import "./NewAssetRegister.vue?vue&type=style&index=0&id=7b2599e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2599e4"]])

export default __exports__